import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import {
  DELETE_HIPAA_CONSENT,
  deleteHipaaAuthConsentFromCache,
} from '@pass-frontend/common/data-access';
import { IMutation } from '@pass-frontend/data-access/common/edge';

export const useDeleteHipaaConsent = () => {
  const [deleteHipaaConsent] = useMutation<
    Pick<IMutation, 'deleteHipaaConsent'>
  >(DELETE_HIPAA_CONSENT, {
    update: deleteHipaaAuthConsentFromCache,
  });

  const handleDeleteHipaaConsent = useCallback(() => {
    return deleteHipaaConsent();
  }, [deleteHipaaConsent]);

  return {
    handleDeleteHipaaConsent,
  };
};
